import { on, popup } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

export const useUnmatchAction = (
  id: string,
  name: string,
  onUnmatchConfirmed: (id: string) => void
) => {
  const { t } = useTranslation();
  const lastIdRef = useRef<string | null>(null);
  const lastNameRef = useRef<string | null>(null);

  useEffect(() => {
    const handlePopupClosed = (payload: { button_id: string }) => {
      if (payload.button_id === 'unmatch' && lastIdRef.current !== null) {
        onUnmatchConfirmed(lastIdRef.current);
        lastIdRef.current = null;
        lastNameRef.current = null;
      }
    };

    // eslint-disable-next-line
    // @ts-ignore
    on('popup_closed', handlePopupClosed);

    return () => {
      // eslint-disable-next-line
      // @ts-ignore
      on('popup_closed', handlePopupClosed);
    };
  }, []);

  return async () => {
    lastIdRef.current = id;
    lastNameRef.current = name;
    await popup.show({
      title: t('unmatch_user_popup_title', { name: name }),
      message: t('unmatch_user_popup_subtitle'),
      buttons: [
        {
          id: 'unmatch',
          type: 'destructive',
          text: t('confirm_unmatch_user_title')
        },
        {
          id: 'cancel',
          type: 'default',
          text: t('cancel_title')
        }
      ]
    });
  };
};
